<template><ProductDetailBase route-key="/products/dry-type" /></template>
<script>
import ProductDetailBase from "./ProductDetailBase.vue";
export default { name: "DryTypePage", components: { ProductDetailBase } };
</script>
